import duration, { createCustom } from './index'

duration.createCustom = createCustom

export default duration
